/**
 * Capitalises the first character in a string
 */
export function capitalize(inputString) {
  const string = String(inputString || '')
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function lowercaseFirstLetter(inputString) {
  const string = String(inputString || '')
  return string.charAt(0).toLowerCase() + string.slice(1)
}

/**
 * Capitalises all characters in the string
 */
export function uppercase(inputString) {
  const string = String(inputString || '')
  return string.toUpperCase()
}
/**
 * Capitalises the first letter of all words in a string
 */
export function capitalizeWords(inputString) {
  const string = String(inputString || '')
  return string.replace(/\b\w/g, l => l.toUpperCase())
}

export function plural(count, singlularString, pluralString, zeroString) {
  if (count === 1) {
    return singlularString
  }

  if (count === 0 && zeroString) {
    return zeroString
  }

  return pluralString
}
